const nepali = {
    name: "Nepali",
    native_name: "नेपाली",
    code: "ne",
  };
  
  const ne = {
    translation: {
      report_bug: "बग रिपोर्ट गर्नुहोस्",
      import: "इम्पोर्ट गर्नुहोस्",
      file: "फाइल",
      new: "नयाँ",
      new_window: "नयाँ विन्डो",
      open: "खोल्नुहोस्",
      save: "सेभ गर्नुहोस्",
      save_as: "यो रूपमा सेभ गर्नुहोस्",
      save_as_template: "टेम्पलेट रूपमा सेभ गर्नुहोस्",
      template_saved: "टेम्पलेट सेभ गरियो!",
      rename: "नाम परिवर्तन गर्नुहोस्",
      delete_diagram: "डायग्राम मेटाउनुहोस्",
      are_you_sure_delete_diagram:
        "के तपाईं पक्का यो डायग्राम मेटाउन चाहनुहुन्छ? यो कार्य पुनः प्राप्त गर्न सकिँदैन।",
      oops_smth_went_wrong: "उफ! केहि गलत भयो।",
      import_diagram: "डायग्राम इम्पोर्ट गर्नुहोस्",
      import_from_source: "स्रोतबाट इम्पोर्ट गर्नुहोस्",
      export_as: "यो रूपमा एक्सपोर्ट गर्नुहोस्",
      export_source: "स्रोत एक्सपोर्ट गर्नुहोस्",
      models: "मोडल्स",
      exit: "निस्कनुहोस्",
      edit: "सम्पादन गर्नुहोस्",
      undo: "पूर्ववत गर्नुहोस्",
      redo: "पुन: गर्नुहोस्",
      clear: "सफा गर्नुहोस्",
      are_you_sure_clear:
        "के तपाईं पक्का यो डायग्राम सफा गर्न चाहनुहुन्छ? यो पुनः प्राप्त गर्न सकिँदैन।",
      cut: "काट्नुहोस्",
      copy: "कपी गर्नुहोस्",
      paste: "पेस्ट गर्नुहोस्",
      duplicate: "डुप्लिकेट गर्नुहोस्",
      delete: "मेटाउनुहोस्",
      copy_as_image: "छविको रूपमा कपी गर्नुहोस्",
      view: "दृश्य",
      header: "हेडर",
      sidebar: "साइडबार",
      issues: "समस्याहरू",
      presentation_mode: "प्रस्तुति मोड",
      strict_mode: "स्ट्रिक्ट मोड",
      field_details: "फिल्ड विवरणहरू",
      reset_view: "दृश्य रिसेट गर्नुहोस्",
      show_grid: "ग्रिड देखाउनुहोस्",
      show_cardinality: "कार्डिनालिटी देखाउनुहोस्",
      theme: "थीम",
      light: "प्रकाश",
      dark: "अँध्यारो",
      zoom_in: "जुम इन गर्नुहोस्",
      zoom_out: "जुम आउट गर्नुहोस्",
      fullscreen: "पूर्ण स्क्रिन",
      settings: "सेटिङ्स",
      show_timeline: "टाइमलाइन देखाउनुहोस्",
      autosave: "स्वतः सेभ",
      panning: "प्यानिङ",
      table_width: "टेबल चौडाइ",
      language: "भाषा",
      flush_storage: "स्टोरेज सफा गर्नुहोस्",
      are_you_sure_flush_storage:
        "के तपाईं पक्का स्टोरेज सफा गर्न चाहनुहुन्छ? यसले तपाईंको सबै डायग्राम र कस्टम टेम्पलेटहरू स्थायी रूपमा मेटाउँछ।",
      storage_flushed: "स्टोरेज सफा गरियो",
      help: "मद्दत",
      shortcuts: "शॉर्टकटहरू",
      ask_on_discord: "हामीलाई Discord मा सोध्नुहोस्",
      feedback: "प्रतिक्रिया",
      no_changes: "कुनै परिवर्तन छैन",
      loading: "लोड हुँदैछ...",
      last_saved: "अन्तिम सेभ गरिएको",
      saving: "सेभ गर्दैछ...",
      failed_to_save: "सेभ गर्न असफल",
      fit_window_reset: "विन्डो फिट गर्नुहोस् / रिसेट गर्नुहोस्",
      zoom: "जुम",
      add_table: "टेबल थप्नुहोस्",
      add_area: "क्षेत्र थप्नुहोस्",
      add_note: "नोट थप्नुहोस्",
      add_type: "प्रकार थप्नुहोस्",
      to_do: "गर्नु पर्ने",
      tables: "टेबलहरू",
      relationships: "सम्बन्धहरू",
      subject_areas: "विषय क्षेत्रहरू",
      notes: "नोटहरू",
      types: "प्रकारहरू",
      search: "खोज्नुहोस्...",
      no_tables: "कुनै टेबलहरू छैनन्",
      no_tables_text: "आफ्नो डायग्राम बनाउन सुरु गर्नुहोस्!",
      no_relationships: "कुनै सम्बन्धहरू छैनन्",
      no_relationships_text: "फिल्डहरू जोड्न तानेर सम्बन्ध बनाउनुहोस्!",
      no_subject_areas: "कुनै विषय क्षेत्रहरू छैनन्",
      no_subject_areas_text: "टेबलहरू समूह गर्न विषय क्षेत्रहरू थप्नुहोस्!",
      no_notes: "कुनै नोटहरू छैनन्",
      no_notes_text: "थप जानकारी रेकर्ड गर्न नोटहरू प्रयोग गर्नुहोस्",
      no_types: "कुनै प्रकारहरू छैनन्",
      no_types_text: "आफ्नो कस्टम डेटा प्रकारहरू बनाउनुहोस्",
      no_issues: "कुनै समस्या पाइएको छैन।",
      strict_mode_is_on_no_issues:
        "स्ट्रिक्ट मोड बन्द छ त्यसैले कुनै समस्या देखाइने छैन।",
      name: "नाम",
      type: "प्रकार",
      null: "नल",
      not_null: "नल होइन",
      primary: "प्राथमिक",
      unique: "युनिक",
      autoincrement: "स्वतः वृद्धि",
      default_value: "डिफल्ट",
      check: "चेक अभिव्यक्ति",
      this_will_appear_as_is: "*यो जेनरेट गरिएको स्क्रिप्टमा जसरी हुन्छ त्यस्तै देखिनेछ।",
      comment: "टिप्पणी",
      add_field: "फिल्ड थप्नुहोस्",
      values: "मानहरू",
      size: "आकार",
      precision: "सटीकता",
      set_precision: "सटीकता सेट गर्नुहोस्: (आकार, अंकहरू)",
      use_for_batch_input: "ब्याच इनपुटका लागि प्रयोग गर्नुहोस्",
      indices: "इन्डिसहरू",
      add_index: "इन्डेक्स थप्नुहोस्",
      select_fields: "फिल्डहरू चयन गर्नुहोस्",
      title: "शीर्षक",
      not_set: "सेट गरिएको छैन",
      foreign: "विदेशी",
      cardinality: "कार्डिनालिटी",
      on_update: "अपडेट गर्दा",
      on_delete: "मेटाउँदा",
      swap: "स्वैप",
      one_to_one: "एक देखि एक",
      one_to_many: "एक देखि धेरै",
      many_to_one: "धेरै देखि एक",
      content: "सामग्री",
      types_info:
        "यो सुविधा object-relational DBMS जस्तै PostgreSQL का लागि हो।\nयदि MySQL वा MariaDB का लागि प्रयोग गरिन्छ भने, एक JSON प्रकार उत्पन्न हुनेछ।\nयदि SQLite का लागि प्रयोग गरिन्छ भने यसलाई BLOB मा परिणत गरिनेछ।\nयदि MSSQL का लागि प्रयोग गरिन्छ भने प्रकार उपनाम बनाइनेछ।",
      table_deleted: "टेबल मेटाइयो",
      area_deleted: "क्षेत्र मेटाइयो",
      note_deleted: "नोट मेटाइयो",
      relationship_deleted: "सम्बन्ध मेटाइयो",
      type_deleted: "प्रकार मेटाइयो",
      cannot_connect: "जोड्न सकिँदैन, कॉलम प्रकारहरू फरक छन्",
      copied_to_clipboard: "क्लिपबोर्डमा कपी गरियो",
      create_new_diagram: "नयाँ डायग्राम बनाउनुहोस्",
      cancel: "रद्द गर्नुहोस्",
      open_diagram: "डायग्राम खोल्नुहोस्",
      rename_diagram: "डायग्रामको नाम परिवर्तन गर्नुहोस्",
      export: "एक्सपोर्ट",
      export_image: "इमेज एक्सपोर्ट गर्नुहोस्",
      create: "बनाउनुहोस्",
      confirm: "पुष्टि गर्नुहोस्",
      last_modified: "अन्तिम पटक संशोधित",
      drag_and_drop_files: "फाइललाई यहाँ तानेर छोड्नुहोस् वा अपलोड गर्न क्लिक गर्नुहोस्।",
      support_json_and_ddb: "JSON र DDB फाइलहरू समर्थित छन्",
      upload_sql_to_generate_diagrams:
        "स्वचालित रूपमा डायग्राम सिर्जना गर्न SQL फाइल अपलोड गर्नुहोस्।",
      overwrite_existing_diagram: "मौजुदा डायग्रामलाई अधिलेखित गर्नुहोस्",
      only_mysql_supported:
        "*हालको लागि केवल MySQL स्क्रिप्टहरू मात्र समर्थित छन्।",
      blank: "खाली",
      filename: "फाइल नाम",
      table_w_no_name: "नाम बिना टेबल घोषणा गरियो",
      duplicate_table_by_name: "नामद्वारा डुप्लिकेट टेबल '{{tableName}}'",
      empty_field_name: "टेबल '{{tableName}}' मा खाली फिल्ड `नाम`",
      empty_field_type: "टेबल '{{tableName}}' मा खाली फिल्ड `प्रकार`",
      no_values_for_field:
      "तालिका '{{tableName}}' को क्षेत्र '{{fieldName}}' को प्रकार `{{type}}` हो तर कुनै मान निर्दिष्ट गरिएको छैन",
    default_doesnt_match_type:
      "तालिका '{{tableName}}' मा क्षेत्र '{{fieldName}}' को डिफ़ल्ट मान यसको प्रकारसँग मेल खाँदैन",
    not_null_is_null:
      "तालिका '{{tableName}}' को क्षेत्र '{{fieldName}}' को मान NOT NULL हो तर डिफ़ल्ट NULL छ",
    duplicate_fields:
      "तालिका '{{tableName}}' मा नाम '{{fieldName}}' भएका दोहोरो तालिका क्षेत्रहरू",
    duplicate_index:
      "तालिका '{{tableName}}' मा नाम '{{indexName}}' भएको दोहोरो सूची",
    empty_index: "तालिका '{{tableName}}' मा सूची कुनै पनि स्तम्भ सूची गरिरहेको छैन",
    no_primary_key: "तालिका '{{tableName}}' मा कुनै प्रमुख कुञ्जी छैन",
    type_with_no_name: "कुनै नाम नभएको प्रकार घोषण गरिएको छ",
    duplicate_types: "नाम '{{typeName}}' भएका दोहोरो प्रकार",
    type_w_no_fields: "कुनै क्षेत्र नभएको प्रकार '{{typeName}}' घोषण गरिएको छ",
    empty_type_field_name: "प्रकार '{{typeName}}' मा खाली क्षेत्र `नाम`",
    empty_type_field_type: "प्रकार '{{typeName}}' मा खाली क्षेत्र `प्रकार`",
    no_values_for_type_field:
      "प्रकार '{{typeName}}' को क्षेत्र '{{fieldName}}' को प्रकार `{{type}}` हो तर कुनै मान निर्दिष्ट गरिएको छैन",
    duplicate_type_fields:
      "प्रकार '{{typeName}}' मा नाम '{{fieldName}}' भएका दोहोरो प्रकार क्षेत्रहरू",
    duplicate_reference: "नाम '{{refName}}' भएको दोहोरो सन्दर्भ",
    circular_dependency: "तालिका '{{refName}}' मा वृत्तीय निर्भरता",
    timeline: "समयरेखा",
    priority: "प्राथमिकता",
    none: "कुनै होइन",
    low: "निम्न",
    medium: "मध्यम",
    high: "उच्च",
    sort_by: "द्वारा क्रमबद्ध गर्नुहोस्",
    my_order: "मेरो क्रम",
    completed: "पूरा",
    alphabetically: "वर्णानुक्रममा",
    add_task: "कार्य थप्नुहोस्",
    details: "विवरण",
    no_tasks: "तपाईंलाई हालसम्म कुनै कार्य छैन।",
    no_activity: "तपाईंलाई हालसम्म कुनै गतिविधि छैन।",
    move_element: "{{name}} लाई {{coords}} मा सार्नुहोस्",
    edit_area: "{{extra}} क्षेत्र सम्पादन गर्नुहोस् {{areaName}}",
    delete_area: "क्षेत्र मेटाउनुहोस् {{areaName}}",
    edit_note: "{{extra}} नोट सम्पादन गर्नुहोस् {{noteTitle}}",
    delete_note: "नोट मेटाउनुहोस् {{noteTitle}}",
    edit_table: "{{extra}} तालिका सम्पादन गर्नुहोस् {{tableName}}",
    delete_table: "तालिका मेटाउनुहोस् {{tableName}}",
    edit_type: "{{extra}} प्रकार सम्पादन गर्नुहोस् {{typeName}}",
    delete_type: "प्रकार मेटाउनुहोस् {{typeName}}",
    add_relationship: "संबन्ध थप्नुहोस्",
    edit_relationship: "{{extra}} सम्बन्ध सम्पादन गर्नुहोस् {{refName}}",
    delete_relationship: "संबन्ध मेटाउनुहोस् {{refName}}",
    not_found: "फेला परेन"
    },
  };
  
  export { ne, nepali };